import { useSelector } from 'react-redux';

import { RootState } from '@/redux/store';

/**
 * Custom hook to verify user access to Fulfillment99.
 */
export const useFulfillAccess = () => {
  const { profile, fulfillAccess } = useSelector((state: RootState) => state.parcel);

  const hasServiceEnabled = profile.data?.configuration?.services?.fulfill99 === true;
  const hasBoAccess = fulfillAccess.hasAccess === true;
  const hasFulfillAccess = hasServiceEnabled && hasBoAccess;
  const isLoading = profile.loading || fulfillAccess.loading;

  return {
    hasFulfillAccess,
    isLoading,
    hasServiceEnabled,
    hasBoAccess,
    checked: fulfillAccess.checked,
  };
};
